const canManageEvent = (currentUser, event) => {
    return (currentUser === event.mainCoordinator.email) || (currentUser === event.creator.email);
};

const CoordinatorPolicy = {
    canManageEvent: canManageEvent
};

export default CoordinatorPolicy;